import FontMain from "../Experiences/FontMain";

export default class LangUtil {
  constructor(elements) {
    this.elements = elements;
  }

  getLangCode() {
    let lang = navigator.language;
    let docLang = document.querySelector("html");

    if (lang.includes("ro")) {
      docLang.setAttribute("lang", "ro");
      docLang = "ro";
    } else {
      docLang.setAttribute("lang", "en");
      docLang = "en";
    }

    return docLang;
  }

  setLangMain(keys) {
    for (let i = 0; i < keys.length; i++) {
      this.getElement(keys[i]).textContent = this.elements[i];
    }
  }

  set3DText(data) {
    for (const key in data) {
      switch (key) {
        case "title":
          new FontMain(
            data[key],
            0.9,
            0.6,
            12,
            true,
            0.05,
            0.02,
            0,
            5,
            0xb90900,
            0,
            0.5,
            0,
            0,
            0,
            0
          );
          break;
        case "message":
          new FontMain(
            data[key],
            0.3,
            0.1,
            12,
            true,
            0.02,
            0.02,
            0,
            1,
            0xffffff,
            0,
            2,
            1.2,
            0,
            0,
            0
          );
          break;
        case "underDev":
          new FontMain(
            data[key],
            0.3,
            0.1,
            12,
            true,
            0.02,
            0.02,
            0,
            0.5,
            0xb90900,
            0,
            3,
            2,
            0,
            0,
            0
          );
          break;
        case "button":
          new FontMain(
            data[key],
            0.9,
            0.1,
            12,
            true,
            0.02,
            0.02,
            0,
            1,
            0xff0000
          );
          break;
        default:
          break;
      }
    }
  }

  getElement(query) {
    return document.getElementById(query);
  }
}
